import { VirtualFolder } from '../Types/mediaCatalog';

export function getMediaFolderOptions(folders: VirtualFolder[]) {
	const options: { Id: number; Name: string }[] = [];
	const visited = new Set<number>();
	const visit = (folder: VirtualFolder, path: string) => {
		if (visited.has(folder.id)) return;
		visited.add(folder.id);
		const name = path ? `${path} / ${folder.name}` : folder.name;
		options.push({ Id: folder.id, Name: name });
		folders.filter((f) => f.parentId === folder.id).sort(compare).forEach((child) => visit(child, name));
	};
	const compare = (a: VirtualFolder, b: VirtualFolder) => a.name.localeCompare(b.name, 'sv', { numeric: true }) || a.id - b.id;
	folders.filter((f) => f.parentId === null).sort(compare).forEach((folder) => visit(folder, ''));
	// Keep orphaned entries usable, and guard against malformed cycles.
	folders.slice().sort(compare).forEach((folder) => { if (!visited.has(folder.id)) visit(folder, ''); });
	return options;
}
